export default function extractURLParams(
  url?: string,
  options?: {
    queryParam?: string
  },
): {
  [k: string]: string
} {
  if (!url) return {}

  try {
    const searchParams = new URL(url).searchParams
    return Object.fromEntries(
      Array.from(searchParams.entries()).filter(([key]) => {
        if (options?.queryParam) return key.includes(options?.queryParam)
        return true
      }),
    )
  } catch (error) {
    return {}
  }
}
